import styled, { css } from 'styled-components';
import Button from '../../../../../components/ui/Button';
import { BREAKPOINTS } from 'constants/breakpoints';

import { colours } from 'themes/default';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const ErrorButton = styled(Button)`
  margin: auto;
`;

export const ModalContainer = styled('div')`
  width: min-content;
  margin: auto;
`;
export const StyledForm = styled.form`
  background-color: ${colours.Greyscale.CloudGrey};
  padding: 10px;
  margin-bottom: 10px;
`;
export const ClassSelectionGrid = styled.div`
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background-color: ${colours.Greyscale.SilverGrey};
  border: 1px solid ${colours.Greyscale.SilverGrey};
  font-weight: normal;
  margin: 15px 0 0 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const ClassSelectionCell = styled.div`
  cursor: pointer;
  background-color: white;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
  padding: 5px 20px;
  white-space: normal;

  ${(props) =>
    props.isDisabled &&
    css`
      cursor: default;
    `}

  ${(props) =>
    props.isSelected &&
    css`
      background-color: ${colours.Core.CoreBlue};
    `}
  
  &:hover {
    background-color: ${colours.Greyscale.SilverGrey};
    ${(props) =>
      props.isDisabled &&
      css`
        background-color: white;
      `}
  }
`;

export const ClassName = styled.div`
  text-align: center;
`;

export const ClassPrice = styled.div`
  text-align: center;
  font-weight: bold;
`;

export const StyledDescription = styled.span`
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: 400;
  vertical-align: bottom;

  &::before {
    content: ' ';
    display: inline;
  }
`;

export const AddCompanionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const StyledSubmitField = styled.div`
  text-align: right;
  display: inline-block;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: block;
    width: 100%;

    > * {
      width: 100%;
      min-height: 32px;
      height: auto;
      white-space: normal;
      word-break: break-word;
    }

    > * > div {
      white-space: normal;
      line-height: 1.3;
    }
  }
`;

export const SearchFareTypeText = styled.p`
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: bold;
`;

export const PassengerTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const PassengerTypeLabel = styled.span`
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 600;
`;

export const PassengerTypeActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 64px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    gap: 8px;

    > * {
      width: 100%;
      min-height: 32px;
      height: auto;
      white-space: normal;
      word-break: break-word;
    }

    > * > div {
      white-space: normal;
      line-height: 1.3;
    }
  }
`;

export const AssistanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AssistanceField = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  > input {
    width: 70px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 8px;

    > input {
      width: 100%;
    }
  }
`;

export const AssistanceLabel = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const StyledAnimalsAlreadyBooked = styled.div`
  text-align: center;
  border-style: solid;
  display: inline-block;
  position: relative;
  white-space: nowrap;
  font-size: 1rem;
  line-height: 20px;
  border-radius: 3px;
  font-weight: 600;
  height: 32px;
  background-color: ${colours.Greyscale.SilverGrey};
  border-color: transparent;
  border-width: 1px;
  margin: 16px 0 16px 0;
  padding: 0 8px 0 8px;
  text-decoration: none;
`;

export const StyledAnimalsAlreadyBookedContent = styled.div`
  color: ${colours.Greyscale.SteelGrey};
  cursor: default;
  padding: 5px 0;
`;

export const StyledAssistancePax = styled.div`
  padding: 10px;
  margin-top: 20px;
  height: 400px;
`;

export const StyledActionWrapper = styled.div`
  margin-left: 10px;
  display: inline-block;
`;
